import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    header: {
        fontSize: 18,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
        paddingHorizontal: 35,
        paddingTop: 5,
        paddingBottom: 8,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingRight: 15,
        paddingTop: 5,
        paddingBottom: 8,
    },
    subtitle: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'center',
        paddingHorizontal: 35,
        paddingTop: 5,
        paddingBottom: 8,
    },
    image: {
        marginLeft: 10,
        width: 80,
        height: 80,
    },
    input: {
        //flexGrow: 0,
        fontSize: 15,
        //width: deviceWidth - 30,
        height: 40,
        marginTop: 0,
        marginBottom: 5,
        marginHorizontal: 15,
        borderWidth: 0.2,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        //color: theme.colors.textPrimary,
        padding: 10,
        textAlignVertical: 'top',
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 10,
    },
    cancelButton: {
        borderWidth: 2,
        borderColor: theme.colors.error,
        backgroundColor: theme.colors.error,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    cancelButtonText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 16,
        textAlign: 'center',
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 8,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 16,
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    flexDirection: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    image: {
        width: 100,
        height: 100,
        borderRadius: 50,
    },
    spacer: {
        height: 12,
    },
})

export default styles
